import React from 'react';
import PropTypes from 'prop-types';
import CheckboxField from '.';

const FormikCheckbox = ({
  field: { name, value },
  form: { setFieldValue },
  instanceId,
  label,
  classNameRoot,
  labelClassName,
  onChange,
  color,
  isDisabled,
  preventDefaultOnChange,
}) => (
  <CheckboxField
    instanceId={instanceId}
    checked={value}
    onChange={v => {
      if (!preventDefaultOnChange) {
        setFieldValue(name, v);
      }
      onChange(v);
    }}
    name={name}
    color={color}
    label={label}
    className={classNameRoot}
    labelClassName={labelClassName}
    disabled={isDisabled}
  />
);

FormikCheckbox.propTypes = {
  classNameRoot: PropTypes.string,
  labelClassName: PropTypes.string,
  onChange: PropTypes.func,
  field: PropTypes.shape({
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    value: PropTypes.bool,
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
  }),
  isDisabled: PropTypes.bool,
  preventDefaultOnChange: PropTypes.bool,
};

FormikCheckbox.defaultProps = {
  onChange: () => {},
  classNameRoot: '',
  labelClassName: '',
  form: {
    setFieldValue: () => {},
  },
  field: {
    value: false,
  },
  isDisabled: false,
  preventDefaultOnChange: false,
};

export default FormikCheckbox;
